module.exports = __webpack_public_path__ + "static/media/39-ack.5443766e.jpg";